import { useEffect } from 'react';
const useDisableBodyScroll = (shouldDisable = true) => {
  useEffect(() => {
    if (shouldDisable) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [shouldDisable]);
};
export default useDisableBodyScroll;